import axios from "axios";
import { base_url } from "../../../utils/baseUrl";
import { config } from "../../../utils/axiosconfig";

const getPages = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = queryString 
    ? `${base_url}cms/pages?${queryString}`
    : `${base_url}cms/pages`;
  const response = await axios.get(url);
  return response.data;
};

const getPage = async (id) => {
  const response = await axios.get(`${base_url}cms/pages/${id}`, config);
  return response.data;
};

const getPageBySlug = async (slug) => {
  const response = await axios.get(`${base_url}cms/pages/slug/${slug}`);
  return response.data;
};

const createPage = async (pageData) => {
  const response = await axios.post(`${base_url}cms/pages`, pageData, config);
  return response.data;
};

const updatePage = async (id, pageData) => {
  const response = await axios.put(
    `${base_url}cms/pages/${id}`,
    pageData,
    config
  );
  return response.data;
};

const uploadPageImages = async (id, formData) => {
  const uploadConfig = {
    ...config,
    headers: {
      ...config.headers,
      "Content-Type": "multipart/form-data",
    },
  };
  const response = await axios.put(
    `${base_url}cms/pages/upload/${id}`,
    formData,
    uploadConfig
  );
  return response.data;
};

const deletePage = async (id) => {
  const response = await axios.delete(`${base_url}cms/pages/${id}`, config);
  return response.data;
};

const cmsPagesService = {
  getPages,
  getPage,
  getPageBySlug,
  createPage,
  updatePage,
  uploadPageImages,
  deletePage,
};

export default cmsPagesService;

